export default __webpack_public_path__ + "static/media/Aboutusshow.bbbf7dea.webp";